<template>
    <div style="width: 100%; display: flex; height: 100vh; overflow: hidden;flex-wrap: wrap;">

        <div style="width: 100%; border-right: 1px solid #e6e6e6; background: #fff; overflow-y: auto; ">
            <el-row style=" padding: 20px; width: 100%;">
                <el-col :span="24">
                    <el-form :inline="true" :model="parentWarehouseSearch" class="demo-form-inline"
                        style="display: flex; align-items: flex-start;flex-wrap: wrap;">

                        <el-button type="primary" size="small" @click="openAddModal1()" :disabled="!currentTypeName"> <i
                                class="el-icon-plus"></i> 新增设备大类模板</el-button>
                        <el-button type="primary" size="small" @click="showAddParentWarehouseDialog()">
                            <i class="el-icon-plus"></i> 新增类型
                        </el-button>
                        <el-button type="primary" size="small" @click="openAddModal()"
                            :disabled="!currentTypeName || !activeSecondCategory"> <i class="el-icon-plus"></i>
                            新增模版</el-button>

                    </el-form>
                </el-col>
                <el-col :span="24" style=" display: flex;width: 100%;margin-top: 10px;">

                    <el-tabs v-model="activeSecondCategory" type="border-card" class="nested-category-tabs"
                        @tab-click="handleSecondCategoryChange">
                        <el-tab-pane v-for="cat in categoryTree" :key="`second-${cat}`" :label="cat" :name="cat">
                            <template #label>
                                <span>{{ cat }}</span>
                                <el-button type="text" size="mini" icon="el-icon-delete"
                                    @click.stop="handleDeleteCategoryByName(cat)"
                                    :disabled="hasChildDeviceInSecondCategory(cat)" class="delete-btn">
                                </el-button>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
            </el-row>
            <div class="category-tabs" style="padding:0 20px;">
                <el-tabs v-model="currentTypeName" type="border-card" class="sub-tabs" @tab-click="handleSubTabChange">
                    <el-tab-pane v-for="subTab in filteredParentWarehouses" :key="subTab.id" :label="subTab.typeName"
                        :name="subTab.typeName">
                        <template #label>
                            <span>{{ subTab.typeName }}</span>
                            <el-button type="text" size="mini" icon="el-icon-delete"
                                @click.stop="handleDeleteType(subTab.id)" :disabled="hasChildDevice(subTab.typeName)"
                                class="delete-btn">
                            </el-button>
                        </template>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div class="page-container">
            <el-row style="padding: 0 20px; height: 65vh; display: flex; flex-direction: column;overflow: auto;">
                <el-col :span="24" class="card-container-wrapper">
                    <div class="card-container" v-loading="listLoading">
                        <el-row :gutter="20">
                            <el-col v-for="(item, index) in deviceList" :key="item.id" class="card-item">
                                <el-card class="room-card"
                                    :class="['device-card', index % 2 === 0 ? 'card-even' : 'card-odd']" shadow="hover">
                                    <div class="card-body">
                                        <div class="device-image">
                                            <img :src="item.photoUrl || item.photo || require('@/assets/bingxiang.png')"
                                                :alt="item.deviceModel + '图片'" class="device-photo">
                                        </div>
                                        <div class="device-info">
                                            <p><i class="el-icon-menu"></i> 模版名称: {{ item.deviceModel }}</p>
                                            <p><i class="el-icon-user"></i> 生产厂家: {{ item.manufacturer || '无' }}</p>
                                            <p><i class="el-icon-s-tools"></i>设备型号: {{ item.deviceModel || '无' }}</p>
                                        </div>
                                        <div class="card-actions">
                                            <el-button size="mini" @click="openDetailDrawer(item)" type="primary"
                                                icon="el-icon-view">详情</el-button>
                                            <el-button size="mini" @click="deleteDevice(item)" type="danger"
                                                icon="el-icon-delete" v-if="roleId == 1">删除</el-button>
                                        </div>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                        <div v-if="deviceList.length === 0 && !listLoading" class="no-data">
                            <el-empty description="暂无符合条件的设备数据"></el-empty>
                        </div>
                    </div>
                    <div class="pagination-container">
                        <el-pagination align="center" @size-change="handleSizeChange"
                            @current-change="handleCurrentChange" :current-page="currentPage"
                            :page-sizes="[4, 8, 16, 32]" :page-size="pageSize" background
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>

            <el-dialog title="新增设备模版" :visible.sync="addModalVisible" width="600px" :close-on-click-modal="false"
                custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true" :z-index="2001">
                <el-form ref="addForm" :model="addForm" :rules="deviceRules" label-width="120px" class="device-form">
                    <el-form-item label="设备模版" prop="deviceModel">
                        <el-input v-model="addForm.deviceModel" placeholder="请输入设备模版"></el-input>
                    </el-form-item>

                    <el-form-item label="设备类型" prop="deviceType">
                        <el-select v-model="addForm.deviceType" placeholder="请选择设备类型" clearable style="width:100%">
                            <el-option v-for="item in filteredParentWarehouses" :key="item.id" :label="item.typeName"
                                :value="item.typeName" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="设备大类" prop="category">
                        <el-select v-model="addForm.category" placeholder="请选择设备大类" clearable style="width:100%">
                            <el-option v-for="item in categoryTree" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="生产厂家" prop="manufacturer">
                        <el-input v-model="addForm.manufacturer" placeholder="请输入生产厂家"></el-input>
                    </el-form-item>
                    <el-form-item label="维保周期" prop="maintenanceCycle">
                        <el-input v-model="addForm.maintenanceCycle" placeholder="请输入维保周期"></el-input>
                    </el-form-item>
                    <el-form-item label="ip地址" prop="ip">
                        <el-input v-model="addForm.ip" placeholder="请输入ip地址"></el-input>
                    </el-form-item>

                    <el-form-item label="设备图片">
                        <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleImageChange"
                            :file-list="addFileList" list-type="picture-preview">
                            <el-button size="small" type="primary">选择图片</el-button>
                            <div slot="tip" class="el-upload__tip">支持PNG格式，大小不超过200k,图片比例3:2</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addModalVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitAddForm()">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="修改设备" :visible.sync="editModalVisible" width="600px" :close-on-click-modal="false"
                custom-class="device-modal" :modal-append-to-body="false" :append-to-body="true" :z-index="2001">
                <el-form ref="editForm" :model="editForm" :rules="deviceRules" label-width="120px" class="device-form">
                    <el-form-item label="生产厂家" prop="manufacturer">
                        <el-input v-model="editForm.manufacturer" placeholder="请输入生产厂家"></el-input>
                    </el-form-item>
                    <el-form-item label="设备型号" prop="deviceModel">
                        <el-input v-model="editForm.deviceModel" placeholder="请输入设备型号"></el-input>
                    </el-form-item>

                    <el-form-item label="设备图片">
                        <el-upload class="upload-demo" action="#" :auto-upload="false" :on-change="handleImageChange"
                            :file-list="editFileList" list-type="picture-preview">
                            <el-button size="small" type="primary">更换图片</el-button>
                            <div slot="tip" class="el-upload__tip">支持JPG/PNG格式，大小不超过200k</div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editModalVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitEditForm()">确定</el-button>
                </div>
            </el-dialog>

            <el-drawer title="设备详情" :visible.sync="detailDrawerVisible" placement="right" size="60%"
                :close-on-click-modal="false" :append-to-body="true" custom-class="detail-drawer" :z-index="2002">
                <el-tabs v-model="activeTab" class="detail-tabs" :stretch="true">
                    <el-tab-pane label="基础信息" name="basic">
                        <div class="detail-container">
                            <div class="detail-header">
                                <h2 class="device-name">{{ currentDevice.deviceName }}</h2>

                            </div>
                            <div class="detail-image">
                                <img :src="currentDevice.photoUrl || currentDevice.photo || 'https://picsum.photos/600/400?random=10'"
                                    :alt="currentDevice.deviceName + '大图'" class="device-big-photo">
                            </div>
                            <el-table :data="detailTableData" border :show-header="false" class="detail-table"
                                style="margin-top: 20px;">
                                <el-table-column prop="label" width="120" align="center"></el-table-column>
                                <el-table-column prop="value" align="left"></el-table-column>
                            </el-table>
                            <div class="detail-actions" style="margin-top: 30px; text-align: right;">
                                <el-button @click="detailDrawerVisible = false">关闭</el-button>
                                <el-button type="primary" @click="goToEdit(currentDevice)">编辑设备</el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="易坏配件库" name="parts">
                        <div class="detail-container">
                            <div class="parts-table" v-loading="partsLoading">
                                <el-table :data="partsList" border style="width: 100%;" :show-header="false">
                                    <el-table-column prop="accessoriesName" width="200">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.accessoriesName" placeholder="配件名称"
                                                clearable></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="accessoriesType" width="200">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.accessoriesType" placeholder="配件类型"
                                                clearable></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="unit" width="200">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.unit" placeholder="配件单位" clearable></el-input>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="remark">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.remark" placeholder="可选备注"
                                                clearable></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column width="80">
                                        <template #default="scope">
                                            <el-button icon="el-icon-delete" @click="handleDeletePart(scope.row)"
                                                type="danger" :disabled="partsList.length <= 1"></el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddPart"
                                style="margin-top: 10px;">添加配件</el-button>

                            <el-button type="primary" size="small" @click="submitPartsChanges()"
                                style="margin-top: 10px;">确定</el-button>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-drawer>

            <el-dialog title="设备类型" :visible.sync="typeModalVisible" width="500px" :close-on-click-modal="false"
                :z-index="2000" append-to-body modal-append-to-body>
                <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="100px">
                    <el-form-item label="类型名称" prop="typeName">
                        <el-input v-model="typeForm.typeName" placeholder="请输入设备类型名称(如留样柜)"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="typeModalVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitTypeForm()">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="设备大类模板" :visible.sync="typeModalVisible1" width="500px" :close-on-click-modal="false"
                :z-index="2000" append-to-body modal-append-to-body>
                <el-form ref="typeForm1" :model="typeForm1" :rules="typeRules1" label-width="100px">
                    <el-form-item label="类型名称" prop="name">
                        <el-input v-model="typeForm1.name" placeholder="请输入设备类型名称（如智能设备）"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="typeModalVisible1 = false">取消</el-button>
                    <el-button type="primary" @click="submitTypeForm1()">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getRoomList } from "@/api/function";
import {
    delDeviceType, addDeviceType, getDeviceTypeList, addModel,
    delModel, edit, getDeviceModeList, getDeviceCategoryList,
    addDeviceCategory, delDeviceCategory
} from "@/api/device";
import { getModelLinkAccessories, addModelLinkAccessories, delModelLinkAccessories } from "@/api/accessories";

export default {

    data() {
        return {
            roleId: '',
            categoryTree: [],
            activeSecondCategory: null,
            typeModalVisible1: false,
            roomList: [],
            deviceTypes: [],
            filteredParentWarehouses: [],
            parentWarehouseSearch: { name: '' },
            currentTypeName: null,
            typeModalVisible: false,
            typeForm: { typeName: '', userId: localStorage.getItem('userId') },
            typeForm1: { name: '', userId: localStorage.getItem('userId') },
            isEditType: false,
            typeRules: {
                typeName: [{ required: true, message: '请输入设备类型名称', trigger: 'blur' }, { min: 1, max: 20, message: '长度在1-20个字符之间', trigger: 'blur' }]
            },
            typeRules1: {
                name: [{ required: true, message: '请输入设备大类名称', trigger: 'blur' }, { min: 1, max: 20, message: '长度在1-20个字符之间', trigger: 'blur' }]
            },

            deviceList: [],
            listLoading: false,
            currentPage: 1,
            pageSize: 8,
            total: 0,

            addModalVisible: false,
            editModalVisible: false,
            detailDrawerVisible: false,
            activeTab: 'basic',
            currentDevice: {},
            addForm: { roomId: '', roomName: '', deviceType: '', category: '', photo: '', deviceModel: '', manufacturer: '', maintenanceCycle: '', ip: '' },
            editForm: { id: '', deviceModel: '', manufacturer: '', roomId: '', deviceType: '', photo: '' },
            addFileList: [],
            editFileList: [],
            deviceRules: {
                manufacturer: [{ required: true, message: '请输入生产厂家', trigger: 'blur' }],
                deviceModel: [{ required: true, message: '请输入设备型号', trigger: 'blur' }],
                deviceType: [{ required: true, message: '设备类型不能为空', trigger: 'blur' }],
                category: [{ required: true, message: '设备大类不能为空', trigger: 'blur' }],
            },
            detailTableData: [],

            partsList: [],
            partsLoading: false,
            originalPartsList: [],
            currentModelId: null,
            deviceModel: null,
        }
    },

    watch: {
        editModalVisible(val) {
            if (!val) {
                this.editForm = { id: '', deviceModel: '', manufacturer: '', roomId: '', deviceType: '', photo: '' };
                this.editFileList = [];
            }
        },
    },

    async mounted() {
        this.roleId = localStorage.getItem('roleId')
        try {
            await Promise.all([this.fetchCategoryTree(), this.loadDeviceTypes(), this.loadRoomList()]);
            if (this.filteredParentWarehouses.length > 0) {
                this.currentTypeName = this.filteredParentWarehouses[0].typeName;
            }
            if (this.categoryTree.length > 0) {
                this.activeSecondCategory = this.categoryTree[0];
            }
            this.getDeviceList();
        } catch (error) {
            console.error("初始化数据加载失败:", error);
        }
    },

    methods: {
        async fetchCategoryTree() {
            try {
                const response = await getDeviceCategoryList({ userId: localStorage.getItem('userId') });
                const flatList = response.data || [];
                this.categoryTree = flatList.filter(cat => cat !== null && cat !== '');
            } catch (error) {
                console.error("获取设备分类失败:", error);
                this.$message.error("获取设备分类失败");
            }
        },

        async getDeviceList() {
            if (!this.currentTypeName || !this.activeSecondCategory) {
                this.deviceList = [];
                this.total = 0;
                return;
            }
            this.listLoading = true;
            const params = {
                param1: this.currentTypeName,
                param2: this.activeSecondCategory,
                userId: localStorage.getItem('userId'),
            };
            try {
                const res = await getDeviceModeList(params);
                if (res.data && res.data.records) {
                    this.deviceList = res.data.records || [];
                    this.total = res.data.total || 0;
                } else {
                    this.deviceList = res.data || [];
                    this.total = res.data.length || 0;
                }
            } catch (error) {
                console.error("加载设备列表失败:", error);
                this.$message.error("加载设备列表失败");
                this.deviceList = [];
                this.total = 0;
            } finally {
                this.listLoading = false;
            }
        },

        async loadRoomList() {
            try {
                const res = await getRoomList({ userId: localStorage.getItem('userId') });
                this.roomList = res.data || [];
            } catch (error) {
                this.$message.error('加载功能间列表失败');
            }
        },
        getRoomName(roomId) {
            if (!roomId) return '未知';
            const room = this.roomList.find(item => item.id === roomId);
            return room ? room.roomName : '未知';
        },

        async loadDeviceTypes() {
            try {
                const res = await getDeviceTypeList({ userId: localStorage.getItem('userId') });
                this.deviceTypes = res.data || [];
                this.filterParentWarehouses();
            } catch (error) {
                this.$message.error('加载设备类型失败');
            }
        },
        filterParentWarehouses() {
            const keyword = this.parentWarehouseSearch.name.toLowerCase();
            this.filteredParentWarehouses = this.deviceTypes.filter(
                item => item.typeName.toLowerCase().includes(keyword)
            );
        },

        handleSubTabChange(tab) {
            this.currentTypeName = tab.name;
            this.currentPage = 1;
            this.getDeviceList();
        },

        hasChildDeviceInSecondCategory(categoryName) {
            return this.deviceList.some(item => item.category === categoryName);
        },

        async handleDeleteCategoryByName(categoryName) {
            if (this.hasChildDeviceInSecondCategory(categoryName)) {
                this.$message.warning('该大类下存在设备，无法删除！');
                return;
            }
            try {
                await this.$confirm(`确定要删除“${categoryName}”这个设备大类吗？`, '提示', { type: 'warning' });
                const response = await delDeviceCategory({ name: categoryName });
                if (response.code !== 200) {
                    this.$message.error(response.message);
                    return;
                }
                this.$message.success('删除成功');
                await this.fetchCategoryTree();
                const isDeletedCategoryActive = this.activeSecondCategory === categoryName;
                if (this.categoryTree.length > 0) {
                    this.activeSecondCategory = this.categoryTree[0];
                } else {
                    this.activeSecondCategory = null;
                }
                if (isDeletedCategoryActive) {
                    this.getDeviceList();
                }
            } catch (error) {
                if (error === 'cancel') {
                    this.$message.info('已取消删除');
                    return;
                }
                console.error('删除分类时发生网络或HTTP错误:', error);
                this.$message.error('操作失败，网络或服务器发生错误。');
            }
        },

        handleSecondCategoryChange() {
            this.currentPage = 1;
            this.getDeviceList();
        },

        hasChildDevice(typeName) {
            return this.deviceList.some(item => item.deviceType === typeName);
        },

        showAddParentWarehouseDialog() {
            this.isEditType = false;
            this.typeForm = { typeName: '', userId: localStorage.getItem('userId') };
            this.typeModalVisible = true;
            this.$nextTick(() => {
                this.$refs.typeForm?.resetFields();
            });
        },
        async handleDeleteType(id) {
            const typeToDelete = this.deviceTypes.find(t => t.id === id);
            if (!typeToDelete) return;

            if (this.hasChildDevice(typeToDelete.typeName)) {
                this.$message.warning('该类型下存在设备，无法删除！');
                return;
            }

            try {
                await this.$confirm('确定要删除该设备类型吗？', '提示', {
                    type: 'warning',
                    cancelButtonText: '取消',
                    confirmButtonText: '确定'
                });

                await delDeviceType({ id, userId: localStorage.getItem('userId') });
                this.$message.success('删除成功');

                if (this.currentTypeName === typeToDelete.typeName) {
                    this.currentTypeName = this.filteredParentWarehouses.length > 0
                        ? this.filteredParentWarehouses[0].typeName
                        : null;
                }

                this.loadDeviceTypes();
                this.getDeviceList();

            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error(error.message || '删除失败');
                }
            }
        },

        async submitTypeForm() {
            this.$refs.typeForm.validate(async (valid) => {
                if (valid) {
                    try {
                        await addDeviceType(this.typeForm);
                        this.$message.success('新增成功');
                        this.typeModalVisible = false
                        this.loadDeviceTypes();
                    } catch (error) {
                        this.$message.error('新增失败');
                    }
                }
            });
        },

        async submitTypeForm1() {
            this.$refs.typeForm1.validate(async (valid) => {
                if (valid) {
                    try {
                        await addDeviceCategory(this.typeForm1);
                        this.$message.success('新增成功');
                        this.typeModalVisible1 = false;
                        this.fetchCategoryTree();
                    } catch (error) {
                        this.$message.error('新增失败');
                    }
                }
            });
        },

        openAddModal1() {
            this.typeForm1 = { name: '', userId: localStorage.getItem('userId') };
            this.typeModalVisible1 = true;
            this.$nextTick(() => {
                this.$refs.typeForm1?.resetFields();
            });
        },

        openAddModal() {
            if (!this.currentTypeName) {
                this.$message.warning('请先在左侧选择一个设备类型');
                return;
            }
            if (!this.activeSecondCategory) {
                this.$message.warning('请先在下方选择一个设备大类');
                return;
            }
            this.addModalVisible = true;
            this.addForm = {
                roomId: '',
                roomName: '',
                deviceType: this.currentTypeName,
                category: this.activeSecondCategory,
                deviceModel: '',
                manufacturer: '',
                maintenanceCycle: '',
                ip: '',
                photo: ''
            };
            this.$nextTick(() => {
                this.$refs.addForm?.resetFields();
                this.addFileList = [];
            });
        },

        // 编辑弹窗图片回显（正常显示图片）
        openEditModal(item) {
            this.currentDevice = { ...item };
            this.editForm = { ...item };
            this.editFileList = [];
            const imgUrl = item.photoUrl || item.photo;
            if (imgUrl) {
                this.editFileList = [{
                    url: imgUrl,
                    name: '设备图片',
                    status: 'success'
                }];
            }
            this.editModalVisible = true;
        },

        async openDetailDrawer(item) {
            console.log(item);

            this.currentDevice = { ...item };
            this.currentModelId = item.id;
            this.deviceModel = item.deviceModel;
            this.detailDrawerVisible = true;
            this.activeTab = 'basic';
            this.detailTableData = [
                { label: '设备类型', value: item.deviceType || '未知' },
                { label: '生产厂家', value: item.manufacturer || '未知' },
                { label: '设备型号', value: item.deviceModel || '未知' },
                { label: '更新时间', value: item.time || '无' },
                { label: '设备状态', value: item.status || '未知' }
            ];
            await this.fetchPartsData(item.deviceModel);
        },

        goToEdit(item) {
            this.detailDrawerVisible = false;
            this.openEditModal(item);
        },

        validateUploadFile(file) {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
                this.$message.error("只能上传图片文件！");
                return false;
            }
            const isLt200K = file.size / 1024 < 200;
            if (!isLt200K) {
                this.$message.error("图片大小不能超过 200k！");
                return false;
            }
            const allowedFormats = ['image/png', 'image/jpg', 'image/jpeg'];
            if (!allowedFormats.includes(file.type)) {
                this.$message.error("仅支持 PNG/JPG/JPEG 格式的图片！");
                return false;
            }
            return true;
        },

        // 已修复：选择图片直接显示图片预览，不显示文件名
        handleImageChange(file, fileList) {
            fileList = fileList.map(item => {
                if (item.raw && !item.url) {
                    const isValid = this.validateUploadFile(item.raw);
                    if (!isValid) {
                        if (this.addModalVisible) this.addFileList = [];
                        if (this.editModalVisible) this.editFileList = [];
                        return item;
                    }
                    item.url = URL.createObjectURL(item.raw);
                    console.log(item.url);

                }
                return item;
            });

            if (this.addModalVisible) {
                this.addFileList = fileList;
            } else if (this.editModalVisible) {
                this.editFileList = fileList;
            }
        },

        async submitAddForm() {
            this.$refs.addForm.validate(async (isValid) => {
                if (isValid) {
                    const formData = new FormData();
                    formData.append("modelName", this.addForm.deviceModel);
                    formData.append("roomId", '1');
                    formData.append("roomName", this.addForm.roomName);
                    formData.append("deviceType", this.addForm.deviceType);
                    formData.append("category", this.addForm.category);
                    formData.append("deviceModel", this.addForm.deviceModel);
                    formData.append("manufacturer", this.addForm.manufacturer);
                    formData.append("maintenanceCycle", this.addForm.maintenanceCycle);
                    formData.append("ip", this.addForm.ip);
                    formData.append("userId", localStorage.getItem("userId"));
                    if (this.addFileList.length > 0 && this.addFileList[0].raw) {
                        formData.append("photo", this.addFileList[0].raw);
                    }
                    try {
                        await addModel(formData);
                        this.$message.success('新增成功');
                        this.addModalVisible = false
                        this.getDeviceList();
                    } catch (error) {
                        console.error("新增设备失败：", error);
                        this.$message.error("操作异常，请重试");
                    }
                }
            });
        },

        async submitEditForm() {
            this.$refs.editForm.validate(async (isValid) => {
                if (isValid) {
                    const formData = new FormData();
                    formData.append("id", this.editForm.id);
                    formData.append("roomId", '1');
                    formData.append("deviceType", this.editForm.deviceType);
                    formData.append("deviceModel", this.editForm.deviceModel);
                    formData.append("manufacturer", this.editForm.manufacturer);
                    formData.append("userId", localStorage.getItem("userId"));
                    if (this.editFileList.length > 0 && this.editFileList[0].raw) {
                        formData.append("photo", this.editFileList[0].raw);
                    }
                    try {
                        await edit(formData);
                        this.editModalVisible = false;
                        this.$message.success("设备修改成功！");
                        this.getDeviceList();
                    } catch (error) {
                        console.error("修改设备失败：", error);
                        this.$message.error("操作异常，请重试");
                    }
                }
            });
        },

        async deleteDevice(item) {
            this.$confirm(`确定要删除 ${item.deviceModel} 吗?`, '提示', { type: 'warning' })
                .then(async () => {
                    try {
                        await delModel({ id: item.id });
                        this.$message.success('删除成功');
                        this.getDeviceList();
                    } catch (error) {
                        console.error('删除设备失败：', error);
                        this.$message.error('操作异常，请重试');
                    }
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getDeviceList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getDeviceList();
        },

        handleRoomChange(roomId) {
            if (!roomId) {
                this.addForm.roomName = '';
                return;
            }
            const selectedRoom = this.roomList.find(room => room.id === roomId);
            if (selectedRoom) {
                this.addForm.roomName = selectedRoom.roomName;
            } else {
                this.addForm.roomName = '';
            }
        },

        handleAddPart() {
            const newId = this.partsList.length > 0 ? Math.max(...this.partsList.map(item => item.id)) + 1 : 1;
            this.partsList.push({
                id: newId,
                accessoriesName: '',
                accessoriesType: '',
                unit: '',
                remark: ''
            });
        },

        async handleDeletePart(row) {
            if (!row.id || row.id < 0) {
                this.partsList = this.partsList.filter(item => item.id !== row.id);
                return;
            }

            try {
                await this.$confirm('确定要删除这个配件吗？', '提示', { type: 'warning' });
                this.partsLoading = true;
                await delModelLinkAccessories({ id: row.id });
                this.$message.success('删除成功');
                this.partsList = this.partsList.filter(item => item.id !== row.id);
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除配件失败:', error);
                    this.$message.error('删除配件失败，请重试');
                }
            } finally {
                this.partsLoading = false;
            }
        },

        async fetchPartsData(deviceModel) {
            this.partsLoading = true;
            try {
                const response = await getModelLinkAccessories({ deviceModel: deviceModel });
                this.partsList = response.data || [];
                this.originalPartsList = JSON.parse(JSON.stringify(this.partsList));
                if (this.partsList.length === 0) {
                    this.handleAddPart();
                }
            } catch (error) {
                console.error('获取配件列表失败:', error);
                this.$message.error('加载配件信息失败');
                this.partsList = [];
                this.handleAddPart();
            } finally {
                this.partsLoading = false;
            }
        },

        async submitPartsChanges() {
            let hasChanges = false;
            const partsToSave = [];

            for (const current of this.partsList) {
                const isNew = !this.originalPartsList.some(o => o.id === current.id);
                let isModified = false;
                if (!isNew) {
                    const original = this.originalPartsList.find(o => o.id === current.id);
                    if (original) {
                        isModified = (
                            current.accessoriesName !== original.accessoriesName ||
                            current.accessoriesType !== original.accessoriesType ||
                            current.unit !== original.unit ||
                            current.remark !== original.remark
                        );
                    }
                }

                if ((isNew || isModified) && current.accessoriesName) {
                    partsToSave.push({
                        ...current,
                        deviceModel: this.deviceModel
                    });
                    hasChanges = true;
                }
            }

            if (!hasChanges) {
                this.$message.info('没有需要保存的配件变更。');
                return;
            }

            this.partsLoading = true;

            try {
                for (const part of partsToSave) {
                    await addModelLinkAccessories(part);
                }
                this.$message.success('所有配件信息已保存');
                this.originalPartsList = JSON.parse(JSON.stringify(this.partsList));

            } catch (error) {
                console.error('保存配件变更失败:', error);
                this.$message.error('保存配件信息失败，请重试');
            } finally {
                this.partsLoading = false;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.category-tabs {
    margin-bottom: 20px;
}

.nested-category-tabs {
    ::v-deep {
        .el-tabs__header {
            margin: 0;
        }

        .el-tabs__content {
            padding: 0;
        }

        .el-tab-pane {
            padding: 0;
        }

        .el-tabs--top.el-tabs--border-card {
            border: none;
        }

        .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
            color: #409EFF;
            border-bottom: 2px solid #409EFF;
            border-right: none;
            border-top: none;
            border-left: none;
        }

        .el-tabs--border-card>.el-tabs__header .el-tabs__item {
            border-radius: 0;
            border-right: 1px solid #EBEEF5;
        }
    }
}

.page-container {
    width: 100%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: #f5f7fa;
    position: relative;
    z-index: 1;
}

.card-container-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    z-index: 1;
    margin-top: 20px;
}

.card-container {
    flex: 1;
    overflow-y: auto;
    padding: 0 20px 20px;
    height: calc(100vh - 20vh);
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.card-item {
    margin-bottom: 20px;
    width: 22%;
    height: 45vh;
}

.device-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    background-color: #fff;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
    }
}

.card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 15px;
    height: 100%;
}

.device-image {
    width: 100%;
    height: 20vh;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f9f9f9;

    .device-photo {
        width: 70%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.5s ease;

        &:hover {
            transform: scale(1.05);
        }
    }
}

.device-info {
    flex: 1;
    font-size: 13px;
    color: #666;
    margin-bottom: 15px;
    max-height: 15vh;
    overflow-y: auto;

    p {
        margin: 6px 0;
        display: flex;
        align-items: center;

        i {
            margin-right: 5px;
            color: #409EFF;
            width: 18px;
            text-align: center;
        }
    }
}

.card-actions {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 5vh;
}

.no-data {
    margin: 50px 0;
    text-align: center;
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-container {
    padding: 20px 0;
    margin-top: auto;
    background-color: #fff;
    z-index: 2;
    position: fixed;
    width: 85%;
    bottom: 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    height: 8vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-even {
    border-top: 3px solid #409EFF;
}

.card-odd {
    border-top: 3px solid #67C23A;
}

.device-form {
    .el-form-item {
        margin-bottom: 20px;
    }

    .el-upload {
        margin-top: 5px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

::v-deep .device-modal {
    z-index: 2001 !important;
}

::v-deep .device-modal+.v-modal {
    z-index: 2000 !important;
}

::v-deep .detail-drawer {
    z-index: 2002 !important;
    height: 100vh !important;

    .el-drawer__body {
        padding: 0 !important;
        height: 100vh;
        overflow-y: auto;
    }
}

::v-deep .detail-tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-tabs__header {
        margin: 0;
        padding: 15px 20px 0;
        border-bottom: 1px solid #e6e6e6;
    }

    .el-tabs__content {
        flex: 1;
        overflow-y: auto;
        padding: 0 20px;
        height: calc(100vh - 80px);
    }

    .el-tab-pane {
        height: 100%;
        padding: 15px 0;
    }
}

.detail-container {
    padding: 0;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 20px;
    height: calc(100vh - 40px);
}

.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.device-name {
    font-size: 18px;
    font-weight: 700;
    color: #333;
    margin: 0;
}

.detail-image {
    width: 100%;
    height: 40vh;
    overflow: hidden;
    border-radius: 6px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.device-big-photo {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.detail-table {
    font-size: 14px;

    .el-table-cell {
        padding: 12px 15px;
        color: #666;
    }

    .el-table__row:nth-child(even) {
        background-color: #fafafa;
    }
}

.detail-actions .el-button {
    margin-left: 10px;
}

.sub-tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs__content {
        display: none;
    }

    ::v-deep .el-tabs__header {
        margin: 0;
        border-bottom: none;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }

    .delete-btn {
        margin-left: 8px;
        color: #F56C6C;
        opacity: 0.7;

        &:hover {
            opacity: 1;
        }
    }
}

.parts-table {
    ::v-deep .el-table {
        --el-table-row-hover-bg-color: #f9fafb;
    }

    .quantity-controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .quantity-value {
            min-width: 20px;
            text-align: center;
        }
    }
}
</style>